import React, { FocusEvent, useState } from 'react'
import InputAdornment from '@material-ui/core/InputAdornment'
import IconButton from '@material-ui/core/IconButton'
import Visibility from '@material-ui/icons/Visibility'
import VisibilityOff from '@material-ui/icons/VisibilityOff'
import TextField from '@material-ui/core/TextField'

export type InputPasswordProps = {
  className?: string
  label?: React.ReactNode
  placeholder?: string
  autoComplete?: string
  name?: string
  value?: unknown
  onChange?: React.ChangeEventHandler<HTMLTextAreaElement | HTMLInputElement>
  error?: boolean
  onBlur?: (
    event: FocusEvent<HTMLTextAreaElement | HTMLInputElement> | undefined
  ) => void
  helperText?: React.ReactNode
  disabled?: boolean
  margin?: 'normal' | 'none' | 'dense'
  fullWidth?: boolean
  InputLabelProps?: { shrink: boolean }
}

export const InputPassword: React.FC<InputPasswordProps> = (props) => {
  const [isShowPassword, setShowPassword] = useState(false)

  const handleClickToggleShowPassword = () => {
    setShowPassword(!isShowPassword)
  }

  return (
    <TextField
      helperText={props.helperText}
      disabled={props.disabled}
      placeholder={props.placeholder}
      error={Boolean(props.error)}
      autoComplete={props.autoComplete}
      value={props.value}
      InputLabelProps={props.InputLabelProps}
      onChange={props.onChange}
      name={props.name}
      label={props.label}
      onBlur={props.onBlur}
      variant="outlined"
      className={props.className}
      margin={props.margin}
      fullWidth={props.fullWidth}
      type={isShowPassword ? 'text' : 'password'}
      InputProps={{
        labelWidth: 103,
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              aria-label="toggle password visibility"
              onClick={handleClickToggleShowPassword}
              onMouseDown={handleClickToggleShowPassword}
              edge="end"
              disabled={props.disabled}
            >
              {isShowPassword ? <Visibility /> : <VisibilityOff />}
            </IconButton>
          </InputAdornment>
        )
      }}
    />
  )
}
